import { render, staticRenderFns } from "./UserGoals.vue?vue&type=template&id=52ba52ae&"
import script from "./UserGoals.vue?vue&type=script&lang=js&"
export * from "./UserGoals.vue?vue&type=script&lang=js&"
import style0 from "./UserGoals.vue?vue&type=style&index=0&id=52ba52ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports